module.exports = __webpack_public_path__ + "img/svg/icon-prizes.79fc5dc5852a724ef622190d37ea24b1.svg";